export default __webpack_public_path__ + "static/media/yael-shimeoni.2798f6c7.png";